import React, { useState } from 'react';
import SEO from '../components/SEO';
import { trackFormSubmit } from '../components/Analytics';
import contactCollaboration from '../assets/images/contact-collaboration.jpg';

function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: ''
  });
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Track form submission
    trackFormSubmit('contact_form', true);
    
    setSubmitted(true);
    setTimeout(() => {
      setSubmitted(false);
      setFormData({
        name: '',
        email: '',
        phone: '',
        message: ''
      });
    }, 3000);
  };

  return (
    <div>
      <SEO 
        title="Contact Us - Get in Touch with Vithminds"
        description="Contact Vithminds Technologies for AI consulting and digital transformation services. Email: info@vithminds.com, Phone: +91 7093694639. Located in Hyderabad, India."
        keywords="contact vithminds, AI consulting contact, digital transformation inquiry, enterprise AI contact"
      />
      
      {/* Hero Image Section */}
      <section className="contact-hero">
        <img 
          src={contactCollaboration} 
          alt="Team Meeting" 
          className="contact-hero-image"
        />
      </section>

      {/* Main Contact Section */}
      <section className="section contact-main-section">
        <div className="contact-container">
          <div className="contact-intro">
            <h1 className="contact-title">Get in Touch!</h1>
            <p className="contact-description">
              We love hearing from you! Whether you have a question, a suggestion, or a compliment, 
              we are always eager to listen and help. Thank you for choosing Vithminds and being part 
              of our community!
            </p>
          </div>

          <div className="contact-content-grid">
            {/* Left Side - Contact Information */}
            <div className="contact-info-section">
              <div className="contact-info-block">
                <div className="contact-info-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                    <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/>
                  </svg>
                </div>
                <h3 className="contact-info-heading">EMAIL</h3>
                <a href="mailto:info@vithminds.com" className="contact-info-link">info@vithminds.com</a>
              </div>

              <div className="contact-info-block">
                <div className="contact-info-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                    <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/>
                  </svg>
                </div>
                <h3 className="contact-info-heading">OFFICE</h3>
                <div className="contact-office-details">
                  <p className="contact-office-label">INDIA:</p>
                  <p className="contact-office-name">Vithminds Technologies Private Limited</p>
                  <p className="contact-office-address">
                    Flat No 302 C Block, Vazhraa Vihhari Manikonda,<br/>
                    Hyderabad, Telangana, India 500089
                  </p>
                </div>
              </div>

              <div className="contact-info-block">
                <div className="contact-info-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                    <path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67z"/>
                  </svg>
                </div>
                <h3 className="contact-info-heading">RESPONSE TIME</h3>
                <p className="contact-info-text">We typically respond within 24 hours</p>
              </div>
            </div>

            {/* Right Side - Contact Form */}
            <div className="contact-form-section">
              {submitted ? (
                <div className="contact-success-message">
                  ✓ Thank you! Your message has been sent successfully.
                </div>
              ) : (
                <form onSubmit={handleSubmit} className="contact-form-new">
                  <div className="form-group-new">
                    <label htmlFor="name">Full Name *</label>
                    <input
                      type="text"
                      id="name"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      required
                      placeholder="John Doe"
                    />
                  </div>

                  <div className="form-group-new">
                    <label htmlFor="email">Email *</label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      required
                      placeholder="john@company.com"
                    />
                  </div>

                  <div className="form-group-new">
                    <label htmlFor="phone">Mobile Number *</label>
                    <input
                      type="tel"
                      id="phone"
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                      required
                      placeholder="+91 1234567890"
                    />
                  </div>

                  <div className="form-group-new">
                    <label htmlFor="message">Message *</label>
                    <textarea
                      id="message"
                      name="message"
                      value={formData.message}
                      onChange={handleChange}
                      required
                      placeholder="Tell us about your project or requirements..."
                      rows="5"
                    ></textarea>
                  </div>

                  <button 
                    type="submit" 
                    className="contact-submit-btn"
                    aria-label="Submit contact form"
                  >
                    Submit
                  </button>
                </form>
              )}
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="contact-cta-section">
        <div className="contact-cta-content">
          <h2>Build AI that works for you</h2>
          <p>Talk to us today about crafting a custom AI solution tailored to your business.</p>
          <a href="#contact-form" className="contact-cta-button">Book a free Consultation</a>
        </div>
      </section>
    </div>
  );
}

export default Contact;